import { create } from 'axios';
import store from '@/store';
import router from '@/router';

const statusMap = {
    401: onUnauthenticated,
    422: onValidationFailed,
};

const instance = create({
    baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

instance.interceptors.request.use(request => {
    const token = store.state.auth.token;

    if (token) {
        request.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return request;
});

/** START response time measuring **/
instance.interceptors.request.use(request => {
    request.meta = request.meta || {};
    request.meta.requestStartedAt = new Date().getTime();

    return request;
});

instance.interceptors.response.use(
    // Handle 2xx & 3xx responses
    response => {
        response.data.responseTime = new Date().getTime() - response.config.meta.requestStartedAt;
        return response;
    },
    // Handle 4xx & 5xx responses
    response => {
        response.responseTime = new Date().getTime() - response.config.meta.requestStartedAt;
        return response;
    },
);
/** END response time measuring **/

instance.interceptors.response.use(
    ({ data }) => data,
    error => Promise.reject(resolveStatus(error)),
);

function resolveStatus(error) {
    const { status } = error.response;

    if (!(status in statusMap)) {
        return error;
    }

    return statusMap[status](error);
}

function onValidationFailed({ response }) {
    return response.data.errors;
}

function onUnauthenticated(error) {
    store.dispatch('auth/removeToken');

    router.push({ name: 'login' });

    return error;
}

export default instance;
